import { TickOutlined as TickIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickOutlined";
import styles from "./Confirmation.module.scss";

export const Confirmation = () => {
  return (
    <div className={styles.successfulConfirmationContainer} aria-live="polite">
      <TickIcon className={styles.tick} size="medium" />
      <div id="notifyme:confirmation:wrapper">
        <p
          data-testid="confirmation:title"
          className={styles.successfulConfirmationTitle}
        >
          We&rsquo;ve just sent you a confirmation email
        </p>

        <p data-testid="confirmation:message">
          We&rsquo;ll contact you when this product becomes available.
        </p>
      </div>
    </div>
  );
};
